export default __webpack_public_path__ + "static/media/pp_connect.104c26ce.png";